import { View } from "dripsy";
import * as React from "react";

function Spacer({
  horizontal = false,
  size = "$2",
}: {
  horizontal?: boolean;
  size?: "$10" | "$8" | "$6" | "$5" | "$4" | "$3" | "$2" | "$1" | 0;
}) {
  return <View sx={{ marginTop: horizontal ? 0 : size, marginLeft: horizontal ? size : 0 }} />;
}
export default Spacer;
